module.exports = __webpack_public_path__ + "img/zombieoffice_14.30845d09.jpg";